import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';

interface BatchDetailsNCFileProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
  ncFileId: number | null;
}

const BatchDetailsNCFileComponent: FC<BatchDetailsNCFileProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  ncFileData,
  ncFileId,
}) => {
  const title = useTitle();

  const { ncFileDataLoading } = useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <NCFileListOrSingleItem
        ncFileData={[ncFileData.data]}
        ncFileDataLoading={!ncFileData.wasLoaded}
        ncFileId={ncFileId}
        ncFileDataLoadingForList={ncFileDataLoading}
      />
    </DetailsPageWrapper>
  );
};

const BatchDetailsNCFile = connect(({ details: { ncFileData, ncFileId } }) => ({ ncFileData, ncFileId }), {
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsNCFileComponent);

export { BatchDetailsNCFile };
